import Vue from 'vue'
import App from './App.vue'
import filters from './filters';
import router from './router/index'
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons/iconfont.css'
import wow from 'wowjs';
import api from "@/api/index.js"
import 'wowjs/css/libs/animate.css';
import * as echarts from 'echarts';

// 引入videojs
import 'video.js/dist/video-js.css';

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.prototype.$wow = wow
Vue.prototype.$echarts = echarts
// import style
import 'swiper/swiper-bundle.css'

import "./assets/fonts/iconfont.css";
import "./assets/css/css.css";


filters(Vue);//使用filter

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper) 

Vue.config.productionTip = false
Vue.prototype.$api = api;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})